var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIconPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3662 37.6338C14.1972 41.3897 18.7418 43.2676 24 43.2676C29.2582 43.2676 33.7653 41.3897 37.5211 37.6338C41.3521 33.8028 43.2676 29.2582 43.2676 24C43.2676 18.7418 41.3521 14.2347 37.5211 10.4789C33.7653 6.64789 29.2582 4.73239 24 4.73239C18.7418 4.73239 14.1972 6.64789 10.3662 10.4789C6.61033 14.2347 4.73239 18.7418 4.73239 24C4.73239 29.2582 6.61033 33.8028 10.3662 37.6338ZM6.98592 7.09859C11.7183 2.3662 17.3897 0 24 0C30.6103 0 36.2441 2.3662 40.9014 7.09859C45.6338 11.7559 48 17.3897 48 24C48 30.6103 45.6338 36.2817 40.9014 41.0141C36.2441 45.6714 30.6103 48 24 48C17.3897 48 11.7183 45.6714 6.98592 41.0141C2.32864 36.2817 0 30.6103 0 24C0 17.3897 2.32864 11.7559 6.98592 7.09859ZM19.1549 34.8169V13.1831L33.5775 24L19.1549 34.8169Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconPreview);
export default __webpack_public_path__ + "static/media/play-icon-preview.47f72cf8.svg";
export { ForwardRef as ReactComponent };